export default __webpack_public_path__ + "static/media/home-startup-blog-img-01.5bbd9b3f.jpg";